//
// RangeSliderController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./PromptElementController";
import "@sas-dvr/ltjs-commons/formatters/Formatter";

var RangeSliderController = createModule("BIRD_RangeSliderController", [40040,40351,40490,40150,40323,40333], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getCurrentDataRange: [[6]],
        hasTemporalData: [2],
        getDefaultRange: [[6]],
        _snapNumericValue_n: [6,6],
        getSnapInterval: [6],
        getFormattedValue: [7,6],
        getCurrentSelectedRangeMagnitude: [6],
        getCurrentSelectedValue: [6],
        isHorizontal: [2],
        setCurrentSelectedValue: [0,6],
        setCurrentSelectedRange: [0,6,6],
        _snapNumericValue_nn: [6,6,6],
        getFormatter: [1],
        getCurrentSelectedRange: [[6]],
    },
    {
        _create: [4,1],
    },
    ["snapNumericValue"],
]);
export default RangeSliderController;
